import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './common-service/auth-gurd.guard';
import { RegisterComponent } from './register/register.component';
import { RegisterComponent1 } from './register1/register1.component';
import { AcceptInspectionScehduleComponent } from './inspection/accept-inspection-scehdule/accept-inspection-scehdule.component';
 import { UidrRegistrationComponent } from './uidr-registration/uidr-registration.component';
 import { PaymentComponent } from './payment/payment.component';
import { UidrCertificateComponent } from './uidr-certificate/uidr-certificate.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotUserComponent } from './forgot-user/forgot-user.component';
//import { TestComponentComponent } from './test-component/test-component.component';
const routes: Routes = [
  
  { path: 'acceptinspectionscehdule/:id/:inspectorid', component: AcceptInspectionScehduleComponent },

  { path: 'login', component: LoginComponent },
  { path: 'login/:module', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'ptr', component: RegisterComponent1 },
  { path: 'forgotpwd', component: ForgotPasswordComponent },
  { path: 'forgotpwd/:module', component: ForgotPasswordComponent },
  { path: 'uidrRegistration', component: UidrRegistrationComponent },
  { path: 'uidrCertificate', component: UidrCertificateComponent },
  //{ path: 'testComponent', component: TestComponentComponent },
  { path: 'payment', component: PaymentComponent },
 // { path: 'ug', component: UgModuleComponent },
  //{ path: 'ugRegistration', component: UgRegistrationComponent },
  //{ path: 'ugNewCollegView', component: UgNewCollegViewComponent },
  { path: 'forgotusr', component: ForgotUserComponent },
  { path: 'forgotusr/:module', component: ForgotUserComponent },
  {
    path: 'main',
    loadChildren: () => import('./common-module/common-module.module').then(c => c.CommonModuleModule),
    canLoad: [AuthGuard]
  },
   {
    path: 'allregister',
    loadChildren: () => import('./allregister/allregister.module').then(c => c.AllregisterModule),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
];

export const AppRoutingRoutes = RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})
